import * as React from "react";
import { APIConfig, newCaregiver } from "../API";
import { Loading, loading } from "../Loading";
import { Caregiver, CaregiverCreateParams } from "../messages/Caregiver";
import { Office } from "../messages";
import { CaregiverCertification } from "src/messages/ObjectIds";
import { useSelector } from "react-redux";
import CaregiverBasicDetailsScreen from "src/components/CaregiverBasicDetailsScreen";
import { AppState } from "src/store/store";
import { useEffect, useState } from "react";

interface NewCaregiverBasicDetailsActivityProps {
    apiConfig: APIConfig;
    authToken: string;
    onSuccessfulLogin: (caregiver: Caregiver, photoUrl: string | null) => void;
    phoneNumber: string;
}

const NewCaregiverBasicDetailsActivity = (props: NewCaregiverBasicDetailsActivityProps) => {
    const [showInternetError, setShowInternetError] = useState<boolean | Loading>(false);
    let isMounted = true;
    const activeOffices: Office[] = useSelector((state: AppState) =>
        state.offices.agencyOffices.filter((office) => office.active));

    const createParams: CaregiverCreateParams = {
        address: "",
        firstName: "",
        lastName: "",
        middleName: "",
        address2: "",
        addressGeoLocation: { lat: 0, lng: 0 },
        addressComponents: null,
        languages: [],
        status: "ACTIVE",
        birthDateDate: undefined,
        caregiverCode: null,
        certification: CaregiverCertification.wrap(""),
        gender: "F",
        homePhone: null,
        phoneNumber: props.phoneNumber,
        photoUrl: null,
        caregiverBranch: null,
        officeIds: activeOffices.length === 1 ? [activeOffices[0].id] : []
    };

    const handleSubmitClick = async (createParams: CaregiverCreateParams, photoUrl: string | null) => {
        setShowInternetError(loading());

        const resp = await newCaregiver(props.apiConfig, props.authToken, createParams);
        setShowInternetError(resp === null);
        if (resp !== null) {
            if (resp.caregiver === undefined) {
                throw new Error("The impossible happened");
            }
            resp.caregiver.officeIds = createParams.officeIds;
            props.onSuccessfulLogin(resp.caregiver, photoUrl);
        }
    };

    useEffect(() => {
        return () => {
            isMounted = false;
        };
    }, []);

    return (
        <CaregiverBasicDetailsScreen
            phoneNumber={props.phoneNumber}
            onSubmitClick={(createParams, photoUrl) => handleSubmitClick(createParams, photoUrl)}
            showInternetError={showInternetError}
            createParams={createParams}
            title={"Just a few more basic details..."}
            certificationsInProgress={[]}
        />
    );
};

export default NewCaregiverBasicDetailsActivity;



// WEBPACK FOOTER //
// ./src/activities/NewCaregiverBasicDetailActivity.tsx